<div class="option-content-particularity pointer" (click)="setNutrienAgreement()">
    <span class="option-title">Convenio Nutrien</span>

    <div class="actions">
        <input type="checkbox" [checked]="nutrienAgreement" class="checkbox"/>
    </div>
</div>